import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "user-order-container" }
const _hoisted_4 = { class: "order-content" }
const _hoisted_5 = {
  key: 0,
  class: "table-outer"
}
const _hoisted_6 = {
  key: 0,
  class: "table-body"
}
const _hoisted_7 = { class: "body-head" }
const _hoisted_8 = { class: "head-item" }
const _hoisted_9 = { class: "head-item" }
const _hoisted_10 = { class: "head-item me-text-beyond" }
const _hoisted_11 = { class: "head-item" }
const _hoisted_12 = { class: "head-item" }
const _hoisted_13 = { class: "body-view" }
const _hoisted_14 = { class: "table-column mdxq-name" }
const _hoisted_15 = { class: "product-principal" }
const _hoisted_16 = { class: "table-column mdxq-address" }
const _hoisted_17 = { class: "product-principal" }
const _hoisted_18 = { class: "product-sku" }
const _hoisted_19 = { class: "table-column mdxq-column" }
const _hoisted_20 = { class: "table-column mdxq-column" }
const _hoisted_21 = {
  key: 1,
  class: "empty"
}
const _hoisted_22 = {
  key: 1,
  class: "table-outer"
}
const _hoisted_23 = {
  key: 0,
  class: "table-body"
}
const _hoisted_24 = { class: "body-head" }
const _hoisted_25 = { class: "head-item" }
const _hoisted_26 = { class: "head-item" }
const _hoisted_27 = { class: "head-item me-text-beyond" }
const _hoisted_28 = { class: "head-item" }
const _hoisted_29 = { class: "head-item" }
const _hoisted_30 = { class: "body-view" }
const _hoisted_31 = { class: "table-column mdxq-name" }
const _hoisted_32 = { class: "product-principal" }
const _hoisted_33 = { class: "table-column mdxq-column" }
const _hoisted_34 = { class: "table-column mdxq-column" }
const _hoisted_35 = { class: "table-column mdxq-column" }
const _hoisted_36 = {
  key: 1,
  class: "empty"
}
const _hoisted_37 = {
  key: 2,
  class: "table-outer"
}
const _hoisted_38 = {
  key: 0,
  class: "table-body"
}
const _hoisted_39 = { class: "body-head" }
const _hoisted_40 = { class: "head-item" }
const _hoisted_41 = { class: "head-item" }
const _hoisted_42 = { class: "head-item" }
const _hoisted_43 = { class: "head-item" }
const _hoisted_44 = { class: "head-item" }
const _hoisted_45 = { class: "head-item me-text-beyond" }
const _hoisted_46 = { class: "table-column commodity-column" }
const _hoisted_47 = { class: "product-principal" }
const _hoisted_48 = {
  key: 0,
  class: "product-sku"
}
const _hoisted_49 = { class: "table-column rests-column" }
const _hoisted_50 = { class: "table-column rests-column" }
const _hoisted_51 = { class: "table-column rests-column" }
const _hoisted_52 = { class: "product-principal" }
const _hoisted_53 = {
  key: 1,
  class: "empty"
}
const _hoisted_54 = {
  key: 0,
  class: "loading"
}
const _hoisted_55 = { class: "footer" }

import { computed, ref, watch, watchEffect } from 'vue';
import { orderStatusFn, disposeServerDateFn, channelFn, mdxqOrderStatusFn, mallOrderStatusFn } from '../../../utils/enum'
import { queryUserOrderApi, queryUserMdxqOrderApi, queryUserMallOrderApi } from '@/utils/user';
import pagination from './pagination.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'orderDetail',
  props: {
    userDetail: {}
  },
  setup(__props: any) {

const isShowPagination = ref(false)
const props = __props

// tab配置相关
const tabList: any = ref([
	{
		name: '近3个月订单',
		key: 'recent3MonthsOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	},
	{
		name: '全部订单',
		key: 'allOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	},
	{
		name: '蔓迪星球订单',
		key: 'mdxqOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	},
	{
		name: '蔓迪商城订单',
		key: 'mallOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	}
])

// 监听tab切换，获取当前tab对应的table的数据
const currentTableOptions:any = computed(() => {
	const result = tabList.value.find((item: any) => item.key === currentActive.value)
	const hasRows = Boolean(result.tableList && result.tableList.length)
	// 商城订单按蔓迪星球 userId 查询，不要求同时存在 syMemberId。
	const canPaginate = currentActive.value === 'mallOrders'
		? Boolean(props.userDetail.id)
		: Boolean(props.userDetail.syMemberId)
	isShowPagination.value = hasRows && canPaginate
	return result;
})

const loading = ref(false)
const currentActive = ref('recent3MonthsOrders');

const isCustomerOrderTab = (key: string) => key === 'mdxqOrders' || key === 'mallOrders'

// 蔓迪商城金额格式化（分 → 元）
const mallPriceFn = (cent: any) => {
	if (cent === null || cent === undefined || cent === '') return '-'
	return '￥' + (Number(cent) / 100).toFixed(2)
}

// 获取订单列表
const getOrderList = async (key: string) => {
	try {
		loading.value = true;
		console.log(currentTableOptions, "currentTableOptions");

		const pageParams: any = {
			"pageNum": currentTableOptions.value.currentPage,
			"pageSize": currentTableOptions.value.pageSize
		}
		let res: any = {}
		if (currentActive.value === 'mdxqOrders') {
			res = await queryUserMdxqOrderApi({
				...pageParams,
				syMemberId: props.userDetail.syMemberId,
				customerId: props.userDetail.id
			})
		} else if (currentActive.value === 'mallOrders') {
			res = await queryUserMallOrderApi({
				...pageParams,
				userId: props.userDetail.id
			})
		} else {
			const params = { ...pageParams, syMemberId: props.userDetail.syMemberId }
			res = await queryUserOrderApi(currentActive.value === 'recent3MonthsOrders' ? { ...params, nearly: 1 } : params)
		}

		tabList.value.map((item: any) => {
			if (item.key === key) {
				item.tableList = res?.body?.list || []
				item.total = res?.body?.count || 0

				console.log('okkoo', tabList.value);

			}
		})
	} catch (err: any) {
		console.log(err);
	} finally {
		loading.value = false;
	}
}


const handleCurrentChange = (val: number) => {
	getOrderList(currentActive.value)
}

const handleSizeChange = (val: number) => {
	getOrderList(currentActive.value)
}


// tab切换
const tabChange = async (item: any) => {
	currentActive.value = item.key
	if (!item.isLoad && props.userDetail.id && (props.userDetail.syMemberId || isCustomerOrderTab(currentActive.value))) {
		item.isLoad = true
		await getOrderList(item.key)
	}
}


const isFirstLoad = ref(true)

// 会话切换时清理上一位用户的订单，避免右侧栏短暂展示旧数据。
watch(() => props.userDetail.id, (userId, previousUserId) => {
	if (!userId || userId === previousUserId) return

	tabList.value.forEach((item: any) => {
		item.isLoad = false
		item.currentPage = 1
		item.total = 0
		item.tableList = []
	})
	isFirstLoad.value = true
}, { immediate: true })

// 监听，如果当前没有syMemberId，就不加载数据
watchEffect(() => {
	if (props.userDetail.id && (props.userDetail.syMemberId || isCustomerOrderTab(currentActive.value))) {
		if (isFirstLoad.value) {
			tabList.value.map((item: any) => {
				if (item.key === currentActive.value) {
					item.isLoad = true
				}
			})
			getOrderList(currentActive.value)
			isFirstLoad.value = false;
		}
	}
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", [item.key === currentActive.value ? 'active' : '']]),
          key: item.key,
          onClick: ($event: any) => (tabChange(item))
        }, _toDisplayString(item.name), 11, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (currentActive.value === 'mdxqOrders')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"table-head\" data-v-638b1763><div class=\"table-column mdxq-name\" data-v-638b1763>礼品名称</div><div class=\"table-column mdxq-address\" data-v-638b1763>收货人/收货地址</div><div class=\"table-column mdxq-column\" data-v-638b1763>数量</div><div class=\"table-column mdxq-column\" data-v-638b1763>消耗能量值</div></div>", 1)),
              (currentTableOptions.value.tableList.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTableOptions.value.tableList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "body-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _cache[2] || (_cache[2] = _createTextVNode("订单号：")),
                            _createElementVNode("span", null, _toDisplayString(item.id), 1)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _cache[3] || (_cache[3] = _createTextVNode("下单时间：")),
                            _createElementVNode("span", null, _toDisplayString(item.order_time), 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[4] || (_cache[4] = _createTextVNode(" 交易状态：")),
                            _createElementVNode("span", null, _toDisplayString(_unref(mdxqOrderStatusFn)(item.status)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _cache[5] || (_cache[5] = _createTextVNode("发货快递：")),
                            _createElementVNode("span", null, _toDisplayString(item.express_company), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _cache[6] || (_cache[6] = _createTextVNode("发货单号：")),
                            _createElementVNode("span", null, _toDisplayString(item.express), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(item.recv_name) + "（" + _toDisplayString(item.recv_mobile) + "）", 1),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(item.address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.num || 0), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.score || 0), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (currentTableOptions.value.tableList.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, "暂无数据"))
                : _createCommentVNode("", true)
            ]))
          : (currentActive.value === 'mallOrders')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"table-head\" data-v-638b1763><div class=\"table-column mdxq-name\" data-v-638b1763>商品名称</div><div class=\"table-column mdxq-column\" data-v-638b1763>数量</div><div class=\"table-column mdxq-column\" data-v-638b1763>应付金额</div><div class=\"table-column mdxq-column\" data-v-638b1763>实付金额</div></div>", 1)),
                (currentTableOptions.value.tableList.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTableOptions.value.tableList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "body-item",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _cache[8] || (_cache[8] = _createTextVNode("订单号：")),
                              _createElementVNode("span", null, _toDisplayString(item.orderId), 1)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _cache[9] || (_cache[9] = _createTextVNode("下单时间：")),
                              _createElementVNode("span", null, _toDisplayString(item.createTime || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _cache[10] || (_cache[10] = _createTextVNode("交易状态：")),
                              _createElementVNode("span", null, _toDisplayString(_unref(mallOrderStatusFn)(item.orderStatus)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _cache[11] || (_cache[11] = _createTextVNode("发货快递：")),
                              _createElementVNode("span", null, _toDisplayString(item.expressCompany || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _cache[12] || (_cache[12] = _createTextVNode("发货单号：")),
                              _createElementVNode("span", null, _toDisplayString(item.express || '-'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, _toDisplayString(item.productName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_33, _toDisplayString(item.quantity || 0), 1),
                            _createElementVNode("div", _hoisted_34, _toDisplayString(mallPriceFn(item.payableAmountCent)), 1),
                            _createElementVNode("div", _hoisted_35, _toDisplayString(mallPriceFn(item.paidAmountCent)), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (currentTableOptions.value.tableList.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "暂无数据"))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"table-head\" data-v-638b1763><div class=\"table-column commodity-column\" data-v-638b1763>商品</div><div class=\"table-column rests-column\" data-v-638b1763>商品标价</div><div class=\"table-column rests-column\" data-v-638b1763>购买数量</div><div class=\"table-column rests-column\" data-v-638b1763>商品实付价</div></div>", 1)),
                (props.userDetail.syMemberId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTableOptions.value.tableList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "body-item",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(channelFn)(item.platCode)) + "-" + _toDisplayString(_unref(channelFn)(item.platCode,
								'shopName')), 1),
                            _createElementVNode("div", _hoisted_41, [
                              _cache[14] || (_cache[14] = _createTextVNode("订单号：")),
                              _createElementVNode("span", null, _toDisplayString(item.orderSn), 1)
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _cache[15] || (_cache[15] = _createTextVNode("下单时间：")),
                              _createElementVNode("span", null, _toDisplayString(_unref(disposeServerDateFn)(item.addTime)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _cache[16] || (_cache[16] = _createTextVNode("付款时间：")),
                              _createElementVNode("span", null, _toDisplayString(_unref(disposeServerDateFn)(item.payTime)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _cache[17] || (_cache[17] = _createTextVNode("完成时间：")),
                              _createElementVNode("span", null, _toDisplayString(_unref(disposeServerDateFn)(item.endTime)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _cache[18] || (_cache[18] = _createTextVNode(" 交易状态：")),
                              _createElementVNode("span", null, _toDisplayString(_unref(orderStatusFn)(item.orderStatus)), 1)
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.syOrderItemList, (orderItem, orderIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "body-view",
                              key: orderIndex
                            }, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, _toDisplayString(orderItem.productName), 1),
                                (orderItem.skuDetail)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(orderItem.skuDetail), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_49, "￥" + _toDisplayString(orderItem.goodsPrice || 0), 1),
                              _createElementVNode("div", _hoisted_50, _toDisplayString(orderItem.goodsNumber || 0), 1),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("span", _hoisted_52, "￥" + _toDisplayString(orderItem.payment || 0), 1)
                              ])
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!props.userDetail.syMemberId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, "暂无数据"))
                  : _createCommentVNode("", true)
              ]))
      ]),
      (loading.value && (props.userDetail.syMemberId || isCustomerOrderTab(currentActive.value)))
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, "加载中..."))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_55, [
      (isShowPagination.value)
        ? (_openBlock(), _createBlock(pagination, {
            key: 0,
            "current-page": currentTableOptions.value.currentPage,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentTableOptions.value.currentPage) = $event)),
            "page-size": currentTableOptions.value.pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((currentTableOptions.value.pageSize) = $event)),
            total: currentTableOptions.value.total,
            "page-sizes": [10, 20, 30, 40],
            layout: "total, sizes, prev, pager, next, jumper",
            background: true,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})